export default __webpack_public_path__ + "land-use-500-178687669dec1cb8ae04515863e29077.png";